import { render, staticRenderFns } from "./filter_berita.vue?vue&type=template&id=4370a573&"
import script from "./filter_berita.vue?vue&type=script&lang=js&"
export * from "./filter_berita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports